import styled from "styled-components";

const Wrapper = styled.button`
  background-color: #6DA6A8 !important;
  color: white !important;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px !important;
  transition: all .3s;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  &:disabled:hover {
    transform: none;
    box-shadow: none;
    background-color: #6DA6A8 !important;
  }

  &:hover {
    background-color: #144344 !important;
    transform: translate3d(0, -2px, 0);
    box-shadow: 0 12px 28px rgba(0, 0, 0, .12);
  }

  & img {
    width: 24px;
    height: 24px;
  }

  &.btn-green {
    background-color: #35955C !important;
  }

  &.btn-green:hover {
    background-color: #21673e !important;
  }
`;
export default function Button({handleClick, alt="", variation="",children, icon = "", iconPosition = "", disabled = false}) {
    return (
        <Wrapper onMouseUp={handleClick} disabled={disabled ? "disabled" : ''} className={variation}>
            {(icon && iconPosition === "left") && <img src={icon} alt="" />}
            {children}
            {(icon && iconPosition === "right") && <img src={icon} alt="" />}
        </Wrapper>
    );
}